/* black-friday.js */
(function () {
  const scripts = document.querySelectorAll('script[src*="black-friday.js"]');
  const sectionIds = [];
  scripts.forEach(script => {
    const id = script.dataset.sectionId;
    if (id && !sectionIds.includes(id)) {
      sectionIds.push(id);
    }
  });

  if (sectionIds.length === 0) return;

  const timerIntervals = {};
  const swiperInstances = {};

  function padZero(num) {
    return num < 10 ? '0' + num : num;
  }

  function initCountdown(id) {
    const countdownContainers = document.querySelectorAll('.js-black-friday-countdown[data-section-id="' + id + '"]');
    
    countdownContainers.forEach(function (container) {
      const userDate = container.getAttribute('data-date');
      const userTime = container.getAttribute('data-time') || '00:00';
      
      const hoursEl = container.querySelector('.countdown-hours');
      const minutesEl = container.querySelector('.countdown-minutes');
      const secondsEl = container.querySelector('.countdown-seconds');
      
      if (!userDate) return;

      const targetString = `${userDate}T${userTime}:00`;
      const targetDate = new Date(targetString);
      
      function update() {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime();
        
        if (difference <= 0) {
          if (timerIntervals[id]) {
            clearInterval(timerIntervals[id]);
            delete timerIntervals[id];
          }
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          return;
        }
        
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        
        if (hoursEl) hoursEl.textContent = padZero(hours);
        if (minutesEl) minutesEl.textContent = padZero(minutes);
        if (secondsEl) secondsEl.textContent = padZero(seconds);
      }
      
      update();
    });
  }

  function initSwiper(id) {
    var swiperEl = document.getElementById('black-friday-swiper-' + id);

    if (!swiperEl || typeof Swiper === 'undefined') return;

    if (swiperInstances[id]) {
      swiperInstances[id].destroy(true, true);
      delete swiperInstances[id];
    }

    var wrapper = swiperEl.closest('.black-friday__slider-wrapper');

    function toggleFades(sw) {
      wrapper.classList.toggle('is-beginning', sw.isBeginning);
      wrapper.classList.toggle('is-end', sw.isEnd);
    }

    swiperInstances[id] = new Swiper(swiperEl, {
      slidesPerView: 4,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: {
        prevEl: '#black-friday-prev-' + id,
        nextEl: '#black-friday-next-' + id
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 12, centeredSlides: true },
        575: { slidesPerView: 2, spaceBetween: 14, centeredSlides: false },
        768: { slidesPerView: 3, spaceBetween: 14, centeredSlides: false },
        992: { slidesPerView: 2, spaceBetween: 16, centeredSlides: false },
        1280: { slidesPerView: 3, spaceBetween: 16, centeredSlides: false }
      },
      on: {
        init: toggleFades,
        slideChange: toggleFades,
        resize: toggleFades
      }
    });
  }

  function startInstance(id) {
    if (timerIntervals[id]) {
      clearInterval(timerIntervals[id]);
    }
    initCountdown(id);
    timerIntervals[id] = setInterval(function() {
      initCountdown(id);
    }, 1000);
    
    initSwiper(id);
  }

  function startAll() {
    const currentScripts = document.querySelectorAll('script[src*="black-friday.js"]');
    currentScripts.forEach(script => {
      const id = script.dataset.sectionId;
      if (id && !sectionIds.includes(id)) {
        sectionIds.push(id);
      }
    });

    sectionIds.forEach(id => {
      startInstance(id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAll);
  } else {
    startAll();
  }

  // Shopify Theme Editor reload support
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('section-6ave-black-friday')) {
      const sectionElement = event.target.querySelector('[data-section-id]');
      const id = sectionElement ? sectionElement.getAttribute('data-section-id') : null;
      if (id) {
        if (!sectionIds.includes(id)) {
          sectionIds.push(id);
        }
        startInstance(id);
      }
    }
  });
})();
